<template>
  <div class="to-valiview">
    <div class="header">
      <img src="/images/htb_banner_2.jpg"/>
    </div>
    <template>
      <div class="QR-box" v-show="QRShow">
        <el-card shadow="hover" class="qr-info">
          <div slot="header" class="card-header">
            <h2>基本信息</h2>
            <el-button style="float: right; padding: 3px 0" type="primary" @click="QRShow = false">验证查看合同</el-button>
          </div>
          <el-form class="qr-form">
            <el-form-item label="文档名称：" class="m-0">
              <span>{{ QRInfo.contractInfo.contractName }}</span>
            </el-form-item>
            <el-form-item label="发起人：" class="m-0">
              <span>{{ QRInfo.contractInfo.platform }}</span>
            </el-form-item>
            <el-form-item label="签约编号：" class="m-0">
              <span>{{ QRInfo.contractInfo.applyNo }}</span>
            </el-form-item>
            <el-form-item label="保全文件Hash(SHA512算法)：" class="m-0">
              <span>{{ QRInfo.contractInfo.hash }}</span>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card shadow="hover" class="qr-info">
          <div slot="header">
            <h2>签署信息</h2>
          </div>
          <div class="qr-form">
            <el-form v-for="user of QRInfo.qrcodeSignInfos" :key="user.idNo">
              <el-form-item label="签署主体：" class="m-0">
                  <span>{{ user.name }}（{{ user.idNo }}）</span>
              </el-form-item>
              <el-form-item label="签署时间：" class="m-0">
                <span>{{ user.signTime }}</span>
              </el-form-item>
              <el-form-item label="最终备案号：" class="m-0">
                <span>{{ user.presId }}</span>
              </el-form-item>
              <el-form-item label="证书序列号：" class="m-0">
                <span>{{ user.sn }}</span>
              </el-form-item>
              <el-form-item label="证书颁发机构：" class="m-0">
                <span>{{ user.issuer }}</span>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
      <el-card v-show="!QRShow" shadow="never" class="card">
        <div class="row">
          <el-input v-model="current.idenNameMask" :disabled="true"></el-input>
        </div>
        <div class="row">
          <el-select v-model="current.select" placeholder="请选择" @change="onSelected">
            <el-option
              v-for="(item,i) in signatoryInfo"
              :key="i"
              :label="item.idenCardMask"
              :value="i">
            </el-option>
          </el-select>
        </div>
        <div class="row">
          <el-input v-model="current.targetMask" :disabled="true"></el-input>
        </div>
        <div class="row">
          <el-input placeholder="请输入验证码" v-model="current.valiCode">
            <template slot="append">
              <el-button @click="sendCode" :disabled="countdownInfo.start" type="success">
                <template v-if="countdownInfo.start">
                  <countdown @on-finish="handleCountdownFinish" v-model="countdownInfo.time"
                            :start="countdownInfo.start"/>
                </template>
                <template v-else>发送验证码</template>
              </el-button>
            </template>
          </el-input>
        </div>
        <div class="row imageCode" v-if="countdownInfo.needImg">
          <el-input v-model="countdownInfo.imgCode" placeholder="图形验证码">
            <template slot="append">
              <img-auth  size="small" ref="imgAuthCode" :verify-type="20" :img-token.sync="countdownInfo.imgToken"/>
            </template>
          </el-input>
        </div>
        <div class="row">
          <el-button @click="certiVali" type="danger" style="width: 100%">确认</el-button>
        </div>
      </el-card>
    </template>
  </div>
</template>

<script>

  import {ApiMethods,} from '../../assets/js/http-serve/http-methods';
  import Countdown from '../../components/countdown/index';
  import ImgAuth from '../../components/img-auth/img-auth'

  export default {
    name: "toValiView",
    components: {Countdown, ImgAuth},
    data() {
      return {
        QRInfo:{
          contractInfo:{},
          qrcodeSignInfos:[]
        },
        QRShow:true,
        signatoryInfo: null,
        current: {
          select: "",
          idenCardMask: "",
          idenNameMask: "",
          signNo: "",
          targetMask: "",
          valiCode: ""
        },
        countdownInfo:
          {time: 120, start: false, needImg: false, imgCode: "", imgToken: ""}  //imgToken_imgCode 图片验证码
      }
    },
    beforeMount() {
      let applyNo = this.$route.query.applyNo;
      let signNo = this.$route.query.signNo;
      this.getQRCodeInfo({applyNo: applyNo,signNo: signNo})
      ApiMethods.CertiController.findCertiVali({applyNo: applyNo,signNo: signNo}).then(result => {
        if (result.success) {
          this.signatoryInfo = result.data;
          this.setDeault();
        } else {
          this.$message.error(result.description || this.$tip)
        }
      }).catch(err => {
        this.$message.error(err.description || this.$tip)
      })
    },
    methods: {
      // 获取二维码详情
      getQRCodeInfo(param){
        ApiMethods.CertiController.qrcodeInfo(param).then(res=>{
          if(!res.success || (res.data && res.data.qrcode !== 1)){
            this.QRShow = false
            return;
          }
          this.QRInfo = res.data
        })
      },
      // 验证码倒计时结束
      handleCountdownFinish() {
        this.countdownInfo = {time: 120, start: false}
      },
      setDeault() {
        if (this.signatoryInfo && this.signatoryInfo.length > 0) {
          this.current = this.signatoryInfo[0]
          this.$set(this.current, 'valiCode',  this.$route.query.code==null?'':this.$route.query.code)
          this.$set(this.current, 'select', this.signatoryInfo[0].idenCardMask)
        }
      },
      onSelected(value) {
        let i = parseInt(value)
        this.current = this.signatoryInfo[i]
        this.$set(this.current, 'valiCode', '')
        this.$set(this.current, 'select', this.signatoryInfo[i].idenCardMask)
      },
      sendCode() {
        let param = {signNo: this.current.signNo}
        if (this.countdownInfo.needImg) {
          param.imgCode = `${this.countdownInfo.imgToken}_${this.countdownInfo.imgCode}`;
        }
        ApiMethods.CertiController.sendCode(param).then(result => {
          if (result.success) {
            this.countdownInfo = {time: 120, start: true};
          } else {
            if (result.code === "10506") { //图形验证码未失效
              this.$message.info(result.description || "图形验证码未失效")
              this.countdownInfo = {time: result.data.num, start: true};
            } else if (result.code === "10103") { //需要图形验证码
              this.$message.info(result.description || "需要图形验证码")
              this.$set(this.countdownInfo,"needImg" , true);
            }else if (result.code === "10602") { //图形验证码格式有误，已失效,请重新获取图形验证码
              this.$message.info(result.description || "图形验证码格式有误")
              this.$set(this.countdownInfo,"needImg" , true);
              //刷新验证码
              this.$refs.imgAuthCode.getImgAuth();
            } else {
              this.$message.error(result.description || this.$tip)
            }
          }
        }).catch(err => {
          console.log(err)
          this.$message.error(err.description || this.$tip)
        })
      },
      certiVali() {
        if (!this.current.valiCode) return this.$message.error("验证码不能为空")
        ApiMethods.CertiController.certiVali({
          signNo: this.current.signNo,
          valicode: this.current.valiCode
        }).then(result => {
          if (result.success) {
            this.$router.push({path: '/applySign/toDetailAnony', query: result.data})
          } else {
            this.$message.error(result.description || this.$tip)
          }
        }).catch(err => {
          this.$message.error(err.description || this.$tip)
        })
      }
    }
  }
</script>
<style>
  .to-valiview .el-input-group__append {
    background-color: #ffffff;
    border: 1px solid #c0c4cc;
    color: #ffffff;
  }
  .to-valiview .imageCode .el-input-group__append {
    padding: 0px;
  }
  .to-valiview .img-auth{
    width: 112px;
    height: 38px;
    padding:1px !important;
  }
  .to-valiview .img__small {
    height: 100% !important;
  }
</style>
<style lang="less" scoped>
  .to-valiview {
    .QR-box{
      margin-top: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .card-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .qr-info{
      width: 48%;
      height: 38vh;
      .qr-form{
        width: 100%;
        height: 28vh;
        overflow-y: auto;
        overflow-x: hidden;
        /deep/ .el-form-item__content {
          word-break: break-word;  /* 兼容性好的写法 */
          white-space: normal;     /* 正常换行 */
          flex: 1;                 /* 如果使用了flex布局 */
          min-width: 0;            /* 解决flex子项文本溢出问题 */
        }
        .m-0{
          margin-bottom: 0;
        }
      }
    }
    .header {
      img {
        width: 100%;
      }
    }
    .card {
      box-sizing: border-box;
      max-width: 540px;
      margin: 60px auto 0;
      padding: 40px 40px;
      background: rgba(255, 255, 255, .7);
    }
    .append{
      width: 70px;
      width: 38px;
    }
    .row {
      display: block;
      padding: 5px 15px;
      font-size: 14px;
      color: #969696;
      border-radius: 4px;
      border: none;
      .el-select {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/certi/toValiView.vue